<template>
    <center><img v-if="content !== null" :src="content.url" :alt="content.description" /></center>
    <center v-if="showCredits">
    <template v-if="content.photographer === content.source">
      Credits: {{ content.source }}
    </template>
    <template v-else>
      Credits: 
      <template v-if="content.photographer">{{ content.photographer }}</template>
      <template v-if="content.photographer && content.source"> | </template>
      <template v-if="content.source">{{ content.source }}</template>
    </template>
  </center>
  </template>
  
  <script>
  export default {
    name: 'ImageContent',
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    computed: {
      showCredits() {
        if (!this.content) return false;
        const { photographer, source } = this.content;
        return (photographer && photographer.trim()) || (source && source.trim());
      }
    }
  }
  </script>
  
  <style scoped>
  /* Add styles for image content if needed */
  </style>
  